(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const routes = {
    raccoon: 'raccoon', cat: 'cats', cats: 'cats', dog: 'dogs', dogs: 'dogs', monkey: 'monkey', bigfoot: 'bigfoot',
    goose: 'goose', frog: 'frog', chicken: 'chicken', 'highland cow': 'highland-cow', horse: 'horse'
  };
  const normalize = value => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  const money = cents => {
    const currency = window.Shopify?.currency?.active || document.documentElement.dataset.currency || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format((Number(cents) || 0) / 100); }
    catch (error) { return `$${((Number(cents) || 0) / 100).toFixed(2)}`; }
  };
  let toastTimer;
  const showToast = message => { const toast = $('#toast'); if (!toast) return; toast.textContent = message; toast.classList.add('is-visible'); clearTimeout(toastTimer); toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2200); };

  const toggleCart = open => {
    $('#cartDrawer')?.classList.toggle('is-open', open);
    $('#drawerOverlay')?.classList.toggle('is-open', open);
    $('#cartDrawer')?.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('is-locked', open);
  };
  const updateCartCount = count => $$('.cart-count').forEach(element => { element.textContent = count; });
  const renderCartDrawer = cart => {
    updateCartCount(cart.item_count);
    const items = $('#cartItems');
    const subtotal = $('#cartSubtotal');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (!items) return;
    if (!cart.items.length) { items.innerHTML = `<div class="cart-empty">${document.body.dataset.cartEmpty || 'Your cart is waiting for a little personality.'}</div>`; return; }
    const removeLabel = document.body.dataset.cartRemove || 'Remove';
    items.innerHTML = cart.items.map(item => `<div class="cart-item" data-cart-item-key="${item.key}"><img src="${item.image || ''}" alt="${item.title.replace(/"/g, '&quot;')}"><div><h3>${item.product_title}</h3><p>${item.variant_title} · Qty ${item.quantity}</p><p>${money(item.final_line_price)}</p></div><button class="remove-item" type="button" data-remove="${item.key}">${removeLabel}</button></div>`).join('');
  };
  const refreshCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(response => response.json()).then(cart => { renderCartDrawer(cart); return cart; });
  const addForm = form => {
    const submit = $('button[type="submit"]', form);
    if (submit?.disabled) return Promise.resolve();
    if (submit) submit.disabled = true;
    const addUrl = /\/cart\/add\/?$/.test(form.action) ? `${form.action}.js` : form.action;
    return fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(response => { if (!response.ok) throw new Error('Add to cart failed'); return response.json(); })
      .then(() => refreshCart()).then(() => { showToast('Added to cart'); toggleCart(true); })
      .catch(() => { form.submit(); })
      .finally(() => { if (submit) submit.disabled = false; });
  };

  document.addEventListener('click', event => {
    const dropdownToggle = event.target.closest('.nav-dropdown-toggle');
    if (dropdownToggle) {
      const dropdown = dropdownToggle.closest('.nav-dropdown');
      const isOpen = dropdown.classList.toggle('is-open');
      dropdownToggle.setAttribute('aria-expanded', String(isOpen));
      return;
    }
    if (!event.target.closest('.nav-dropdown')) {
      $$('.nav-dropdown.is-open').forEach(dropdown => { dropdown.classList.remove('is-open'); $('.nav-dropdown-toggle', dropdown)?.setAttribute('aria-expanded', 'false'); });
    }
    const animalElement = event.target.closest('[data-filter], [data-search]');
    if (animalElement) {
      const handle = routes[normalize(animalElement.dataset.filter || animalElement.dataset.search)];
      if (handle) { event.preventDefault(); window.location.assign(`/collections/${handle}`); return; }
    }
    if (event.target.closest('.cart-button')) { refreshCart().finally(() => toggleCart(true)); return; }
    if (event.target.closest('.drawer-close') || event.target.id === 'drawerOverlay') { toggleCart(false); return; }
    const remove = event.target.closest('[data-remove]');
    if (remove) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: remove.dataset.remove, quantity: 0 }) }).then(response => response.json()).then(renderCartDrawer);
      return;
    }
    const menuToggle = event.target.closest('.menu-toggle');
    if (menuToggle) { const menu = $('.mobile-menu'); const open = menu.classList.toggle('is-open'); menuToggle.setAttribute('aria-expanded', String(open)); }
    const qtyButton = event.target.closest('[data-qty]');
    if (qtyButton) {
      const quantity = $('#detailQuantity');
      const quantityInput = $('[data-product-quantity]');
      if (quantity) {
        const nextQuantity = Math.max(1, Math.min(10, Number(quantity.textContent) + (qtyButton.dataset.qty === 'plus' ? 1 : -1)));
        quantity.textContent = nextQuantity;
        if (quantityInput) quantityInput.value = String(nextQuantity);
      }
    }
    const buyNow = event.target.closest('[data-buy-now]');
    if (buyNow) {
      const form = buyNow.closest('.product-form');
      if (!form || buyNow.disabled) return;
      buyNow.disabled = true;
      const addUrl = /\/cart\/add\/?$/.test(form.action) ? `${form.action}.js` : form.action;
      fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(response => { if (!response.ok) throw new Error('Buy now failed'); return response.json(); })
        .then(() => { window.location.assign('/checkout'); })
        .catch(() => { buyNow.disabled = false; form.submit(); });
    }
  });

  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('#searchForm')) {
      const handle = routes[normalize($('#searchInput', form)?.value)];
      if (handle) { event.preventDefault(); window.location.assign(`/collections/${handle}`); }
      return;
    }
    if (form.matches('.product-form')) { event.preventDefault(); addForm(form); }
  });

  const productForm = $('[data-product-form]');
  const variantData = $('[data-product-variants]');
  const productGallery = $('[data-product-gallery]');

  // Keep the main product description compact on both desktop and mobile.
  // Show the full description only after the customer chooses "See more".
  const descriptionWrap = $('[data-description-wrap]');
  const descriptionCopy = $('[data-description-copy]');
  const descriptionToggle = $('[data-description-toggle]');
  const syncDescriptionToggle = () => {
    if (!descriptionWrap || !descriptionCopy || !descriptionToggle) return;
    if (descriptionWrap.classList.contains('is-expanded')) return;
    const textLength = (descriptionCopy.textContent || '').replace(/\s+/g, ' ').trim().length;
    const hasOverflow = descriptionCopy.scrollHeight > descriptionCopy.clientHeight + 2;
    // Keep the control available for meaningful product descriptions even on
    // mobile, where the available height can change after fonts/images load.
    descriptionToggle.hidden = !(hasOverflow || textLength > 220);
  };
  if (descriptionWrap && descriptionCopy && descriptionToggle) {
    descriptionToggle.addEventListener('click', () => {
      const expanded = descriptionWrap.classList.toggle('is-expanded');
      descriptionToggle.setAttribute('aria-expanded', String(expanded));
      descriptionToggle.textContent = expanded ? 'See less' : 'See more';
    });
    requestAnimationFrame(syncDescriptionToggle);
    window.addEventListener('resize', syncDescriptionToggle);
  }

  const galleryMediaId = value => String(value || '');
  const setGalleryMedia = mediaId => {
    if (!productGallery || !mediaId) return;
    const id = galleryMediaId(mediaId);
    const track = $('[data-gallery-track]', productGallery);
    const slides = $$('[data-media-id]', track || productGallery);
    const thumbs = $$('[data-gallery-thumb]', productGallery);
    const slide = slides.find(item => galleryMediaId(item.dataset.mediaId) === id);
    if (!slide) return;

    // Restore the original Shopify image if this slide was temporarily used
    // to display a color mockup.
    const restoredImage = slide.querySelector('img');
    if (restoredImage && slide.dataset.originalSrc) {
      restoredImage.src = slide.dataset.originalSrc;
      delete slide.dataset.originalSrc;
    }

    if (track) {
      const left = slide.offsetLeft;
      track.scrollTo({ left, behavior: 'smooth' });
    }

    slides.forEach(item => item.classList.toggle('is-active', item === slide));
    thumbs.forEach(item => {
      const active = galleryMediaId(item.dataset.mediaId) === id;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
  };

  const syncGalleryActiveFromScroll = () => {
    if (!productGallery) return;
    const track = $('[data-gallery-track]', productGallery);
    if (!track) return;
    const slides = $$('[data-media-id]', track);
    if (!slides.length) return;
    let closest = slides[0];
    let distance = Infinity;
    slides.forEach(slide => {
      const d = Math.abs(slide.offsetLeft - track.scrollLeft);
      if (d < distance) { distance = d; closest = slide; }
    });
    const id = closest.dataset.mediaId;
    slides.forEach(item => item.classList.toggle('is-active', item === closest));
    $$('[data-gallery-thumb]', productGallery).forEach(item => {
      const active = galleryMediaId(item.dataset.mediaId) === galleryMediaId(id);
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
  };

  if (productGallery) {
    const track = $('[data-gallery-track]', productGallery);
    $$('[data-gallery-thumb]', productGallery).forEach(thumb => {
      thumb.addEventListener('click', () => setGalleryMedia(thumb.dataset.mediaId));
    });

    $('[data-gallery-prev]', productGallery)?.addEventListener('click', () => {
      if (!track) return;
      track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
    $('[data-gallery-next]', productGallery)?.addEventListener('click', () => {
      if (!track) return;
      track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
    });

    if (track) {
      let scrollTimer;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(syncGalleryActiveFromScroll, 80);
      }, { passive: true });
    }
  }

  if (productForm && variantData) {
    let variants = [];
    try { variants = JSON.parse(variantData.textContent); } catch (error) { variants = []; }

    const optionGroups = $$('[data-option-index]', productForm);
    const optionButtons = $$('[data-option-value]', productForm);
    const selectedOptions = optionGroups.map(group => $('.is-selected', group)?.dataset.optionValue || '');

    const syncVariant = (focusGallery = true) => {
      // First try the exact combination. If that combination does not exist or
      // is sold out, fall back to an available variant matching the option the
      // customer just changed. This keeps Printify products with different
      // size/color availability usable without requiring manual product setup.
      let variant = variants.find(item => item.options?.every((value, index) => value === selectedOptions[index]));
      if (!variant || !variant.available) {
        const changedIndex = syncVariant.lastChangedIndex;
        if (changedIndex !== undefined) {
          variant = variants.find(item => item.available && item.options?.[changedIndex] === selectedOptions[changedIndex]);
        }
      }
      const idInput = $('[data-variant-id]', productForm);
      const price = $('[data-product-price]');
      const availability = $('[data-availability]');
      const submit = $('button[type="submit"]', productForm);

      if (!variant) {
        if (submit) submit.disabled = true;
        return;
      }

      // If we had to fall back, reflect the real variant selections in the UI.
      if (variant.options) {
        variant.options.forEach((value, index) => {
          selectedOptions[index] = value;
          const group = optionGroups.find(item => Number(item.dataset.optionIndex) === index);
          if (!group) return;
          $$('[data-option-value]', group).forEach(option => {
            option.classList.toggle('is-selected', option.dataset.optionValue === value);
          });
          const selected = $('[data-selected-option]', group);
          if (selected) selected.textContent = value;
        });
      }

      if (idInput) idInput.value = variant.id;
      if (price) price.innerHTML = `<span>${money(variant.price)}${variant.compare_at_price > variant.price ? `</span><span class="compare">${money(variant.compare_at_price)}` : ''}</span>`;
      if (availability) availability.textContent = variant.available ? 'Available' : 'Sold out';
      if (submit) submit.disabled = !variant.available;
      const buyNow = $('[data-buy-now]', productForm);
      if (buyNow) buyNow.disabled = !variant.available;

      if (focusGallery) {
        // Use the real Shopify variant -> media relationship first.
        // This is the only reliable way to show the exact Printify mockup
        // for a selected color/size when Shopify has variant media assigned.
        const exactMediaId = variant.featuredMediaId || '';
        const fallbackMediaId = variant.fallbackMediaId || '';

        if (exactMediaId) {
          const matchingSlide = $$('[data-media-id]', productGallery).find(
            slide => String(slide.dataset.mediaId) === String(exactMediaId)
          );
          if (matchingSlide) {
            setGalleryMedia(exactMediaId);
            return;
          }
        }

        if (fallbackMediaId) {
          const matchingSlide = $$('[data-media-id]', productGallery).find(
            slide => String(slide.dataset.mediaId) === String(fallbackMediaId)
          );
          if (matchingSlide) {
            setGalleryMedia(fallbackMediaId);
            return;
          }
        }

        // Final fallback for products where Printify did not preserve a
        // variant-media relationship: use the color button's mapped media.
        const colorGroup = optionGroups.find(group => {
          const label = $('.option-label span', group)?.textContent || '';
          return /color|colour/i.test(label);
        });
        const colorIndex = colorGroup ? Number(colorGroup.dataset.optionIndex) : -1;
        const colorValue = colorIndex >= 0 ? selectedOptions[colorIndex] : '';
        const colorButton = colorGroup
          ? $$('[data-option-value]', colorGroup).find(button => button.dataset.optionValue === colorValue)
          : null;
        const colorMediaId = colorButton?.dataset.colorMediaId || '';
        if (colorMediaId) setGalleryMedia(colorMediaId);
      }
    };

    // Keep the first product media as the initial image. Variant/color media
    // is only selected after the customer clicks an option.
    if (productGallery) {
      const initialSlide = $('[data-initial-media="true"]', productGallery);
      if (initialSlide) {
        const initialId = initialSlide.dataset.mediaId;
        $$('[data-media-id]', productGallery).forEach(slide => slide.classList.toggle('is-active', slide === initialSlide));
        $$('[data-gallery-thumb]', productGallery).forEach(thumb => {
          const active = thumb.dataset.mediaId === initialId;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', String(active));
        });
      }
    }

    optionButtons.forEach(button => button.addEventListener('click', () => {
      const group = button.closest('[data-option-index]');
      if (!group) return;
      const index = Number(group.dataset.optionIndex);
      $$('[data-option-value]', group).forEach(option => option.classList.remove('is-selected'));
      button.classList.add('is-selected');
      selectedOptions[index] = button.dataset.optionValue;
      syncVariant.lastChangedIndex = index;
      const selected = $('[data-selected-option]', group);
      if (selected) selected.textContent = button.dataset.optionValue;
      syncVariant(true);
    }));

  }

})();